import React from 'react';
import { Outlet } from 'react-router-dom';
import SidebarV2 from '../navigation/SidebarV2';

/**
 * AdminShell - Layout wrapper for Admin pages
 * Renders Sidebar (SidebarV2) + content area (via Outlet)
 * Topbar is handled by AppChrome parent
 * SidebarV2 handles both Agent and Admin modes via navMode and route.
 */
const AdminShell = () => {
  return (
    <div className="flex flex-1 min-h-0 h-full bg-gray-50">
      <SidebarV2 />
      <main className="overflow-auto flex-1 p-6 w-full min-h-0 bg-gray-50">
        <div className="mx-auto max-w-7xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminShell;

